import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { OriginatorListingFilters } from "../listing/useOriginatorListingFilters";
import { OriginatorListingItem } from "./OriginatorListingItem";

interface IOriginatorListingContext {
    items: OriginatorListingItem[];
    allItems: OriginatorListingItem[];
    totalItems: number;
    isLoading: boolean;
    add(item: OriginatorListingItem): void;
    load(filters: OriginatorListingFilters): void;
}

const initialContextState: IOriginatorListingContext = {
    items: [],
    allItems: [],
    totalItems: 0,
    isLoading: false,
    add: contextFunctionInit,
    load: contextFunctionInit
};

export const OriginatorListingContext = createContext<IOriginatorListingContext>(initialContextState);
